export const ORDER_TYPE = {
  /** 官網訂單 */
  WP_ORDER: 'wp_order',

  /** 第三方銷售訂單 */
  MANUAL_ORDER: 'manual_order',

  /** Fastpass 子訂單 */
  FAST_PASS: 'fast_pass',

  /** Fastpass 母訂單 */
  FAST_PASS_PARENT: 'fast_pass_parent',

  /** Shopee 訂單 */
  SHOPEE: 'shopee',

  /** Amazon 訂單 */
  AMAZON: 'amazon',

  /** Pinkoi 訂單 */
  PINKOI: 'pinkoi',

  /** 部門領料 */
  DEPT_PICKUP: 'dept_pickup',

  /** 部門退料 */
  DEPT_RETURN: 'dept_return',

  /** 倉庫調撥 */
  STOCK_TRANSFER: 'stock_transfer',

  /** 純出貨 */
  ONLY_DELIVER_OUT: 'only_deliver_out',

  /** 純收貨 */
  ONLY_DELIVER_IN: 'only_deliver_in',

  /** 官網退貨單 */
  WP_RETURN_ORDER: 'wp_return_order',

  /** 第三方退貨單 */
  RETURN_ORDER: 'return_order',

  /** Presco 虛擬訂單 */
  VIRTUAL_ORDER_TYPE: 'presco_virtual_order',

  /** MOMO 訂單 */
  MOMO: 'momo',

  /** HKTVMall 訂單 */
  HKTVMALL: 'hktv',
} as const

export const ORDER_TYPE_MAP = {
  [ORDER_TYPE.WP_ORDER]: '銷售訂單-官網訂單',
  [ORDER_TYPE.MANUAL_ORDER]: '銷售訂單-手建表單',
  [ORDER_TYPE.FAST_PASS]: '銷售訂單-電子宅配單',
  [ORDER_TYPE.FAST_PASS_PARENT]: '銷售訂單-電子宅配母訂單',
  [ORDER_TYPE.SHOPEE]: '銷售訂單-蝦皮訂單',
  [ORDER_TYPE.AMAZON]: '銷售訂單-亞馬遜訂單',
  [ORDER_TYPE.PINKOI]: '銷售訂單-Pinkoi訂單',
  [ORDER_TYPE.MOMO]: '銷售訂單-MOMO訂單',
  [ORDER_TYPE.HKTVMALL]: '銷售訂單-HKTV訂單',

  [ORDER_TYPE.DEPT_PICKUP]: '部門領料',
  [ORDER_TYPE.DEPT_RETURN]: '部門退料',
  [ORDER_TYPE.STOCK_TRANSFER]: '倉庫調撥',
  [ORDER_TYPE.ONLY_DELIVER_OUT]: '純出貨',
  [ORDER_TYPE.ONLY_DELIVER_IN]: '純收貨',

  [ORDER_TYPE.WP_RETURN_ORDER]: '官網退貨單',
  [ORDER_TYPE.RETURN_ORDER]: '第三方退貨單',

  [ORDER_TYPE.VIRTUAL_ORDER_TYPE]: '虛擬訂單-Presco',
} as const
